import { render, staticRenderFns } from "./InternationalSlider.vue?vue&type=template&id=a35f5844&"
import script from "./InternationalSlider.vue?vue&type=script&lang=js&"
export * from "./InternationalSlider.vue?vue&type=script&lang=js&"
import style0 from "./InternationalSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports